import type { ReactNode } from 'react';

import { usePsapConfiguration } from './PsapConfigurationContext';

export type PsapViewProps = {
  psapId?: string;
  psapIds?: string[];
  children?: ReactNode;
};

export function PsapView({ psapId, psapIds, children }: PsapViewProps) {
  const psapConfiguration = usePsapConfiguration();

  const effectivePsapIds =
    psapIds != null
      ? psapId != null
        ? [...psapIds, psapId]
        : psapIds
      : psapId != null
        ? [psapId]
        : (() => {
            throw new Error('At least one of the parameters psapId or psapIds must be set.');
          })();

  const isVisible =
    psapConfiguration != null && effectivePsapIds.includes(psapConfiguration.id);

  return isVisible ? <>{children}</> : null;
}
